
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import no from './no.json';
import en from './en.json';
import vi from './vi.json';

const normalizeLanguage = (lang?: string | null): string => {
    const normalized = String(lang || '').toLowerCase();
    if (normalized === 'no' || normalized.startsWith('nb')) return 'nb';
    if (normalized === 'vi' || normalized.startsWith('vi-')) return 'vi';
    if (normalized === 'en' || normalized.startsWith('en-')) return 'en';
    return 'nb';
};

const storedLang =
    localStorage.getItem('Language') ||
    localStorage.getItem('Lang') ||
    localStorage.getItem('lang');
const userLang = normalizeLanguage(storedLang);

i18n.use(initReactI18next).init({
    resources: {
        nb: { translation: no },
        no: { translation: no },
        en: { translation: en },
        vi: { translation: vi }
    },
    lng: userLang,
    fallbackLng: 'nb',
    interpolation: {
        escapeValue: false
    }
});

export default i18n;
